import { Box, Typography } from "@mui/material";
import { useAppContext } from "../../../../2_ksbHub/context/appContext";

export const ChatAppTitle = () => {
  const { isMobile } = useAppContext();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "row" : "column",
        alignItems: isMobile ? "flex-end" : "flex-start", // ✅ bottom align on mobile
        gap: isMobile ? 0 : 0,
        whiteSpace: "nowrap",
      }}
    >
      {/* ✅ Desktop only */}
      {!isMobile && (
        <Typography variant="h6" color="primary">
          KSB
        </Typography>
      )}

      {/* ✅ Main title */}
      <Typography
        color="primary"
        variant={isMobile ? "h6" : "h4"}
        fontWeight="bold"
      >
        Chat App
      </Typography>

      {/* ✅ Subtitle */}
      <Typography
        color="primary"
        variant="caption"
        sx={{
          ml: isMobile ? 1 : 0,
          mb: isMobile ? "-1px" : 0, // ✅ align visually with main title
        }}
      >
        von Vittoria Huber
      </Typography>
    </Box>
  );
};
